// Cards whose names are kept without a space (saved games, moves and lookups use them so, and must go on doing so),
// as they are shown: their names as printed
const ShownNames = {
    'ConstitutionalMonarchy': 'Constitutional Monarchy',
    'AirForces': 'Air Forces',
};

const Pattern = new RegExp(`\\b(${Object.keys(ShownNames).join('|')})\\b`, 'g');

// Text to show (a card's name, a journal line, an option's label), with those names as printed; anything else as it is
const ShownName = (text) => typeof text === 'string' ? text.replace(Pattern, name => ShownNames[name]) : text;

module.exports = { ShownNames, ShownName };
